import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

const inputCls = "w-full border border-line bg-ink px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-accent";

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="font-mono text-[10px] tracking-[0.3em] text-gray-500">{label}</span>
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

export default function AdminHome() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api
      .get("/admin/home")
      .then((r) => setForm(r.data))
      .catch(() => toast.error("取得に失敗しました"));
  }, []);

  if (!form) {
    return <p className="font-mono text-sm tracking-[0.3em] text-gray-500">LOADING...</p>;
  }

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));
  const setStep = (i, key) => (e) =>
    setForm((f) => ({
      ...f,
      flow_steps: f.flow_steps.map((r, j) => (j === i ? { ...r, [key]: e.target.value } : r)),
    }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { id, ...payload } = form;
      await api.put("/admin/home", payload);
      toast.success("保存しました");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-home-page">
      <h1 className="font-mincho text-2xl font-bold text-white">トップページ の編集</h1>
      <p className="mt-1 font-mono text-[10px] tracking-[0.3em] text-gray-500">HOME PAGE MANAGEMENT</p>

      <form onSubmit={save} className="mt-8 max-w-3xl space-y-10">
        <section className="border border-line bg-panel p-6">
          <h2 className="font-mincho text-lg font-bold text-white">ブランドメッセージ</h2>
          <div className="mt-5 space-y-4">
            <div className="grid gap-4 sm:grid-cols-2">
              <Field label="大見出し（1行目）">
                <input data-testid="home-brand-title-1" value={form.brand_title_1} onChange={set("brand_title_1")} className={inputCls} />
              </Field>
              <Field label="大見出し（2行目）">
                <input data-testid="home-brand-title-2" value={form.brand_title_2} onChange={set("brand_title_2")} className={inputCls} />
              </Field>
            </div>
            <Field label="説明文">
              <textarea data-testid="home-brand-sub" rows={3} value={form.brand_sub} onChange={set("brand_sub")} className={`resize-y leading-7 ${inputCls}`} />
            </Field>
          </div>
        </section>

        <section className="border border-line bg-panel p-6">
          <h2 className="font-mincho text-lg font-bold text-white">4つのステップ（土地を整える 等）</h2>
          <div className="mt-5 space-y-6">
            {form.flow_steps.map((s, i) => (
              <div key={i} data-testid={`flow-form-${i}`} className="space-y-3 border border-line bg-ink p-4">
                <p className="font-mono text-[10px] tracking-[0.25em] text-accent">STEP {String(i + 1).padStart(2, "0")}</p>
                <Field label="タイトル">
                  <input data-testid={`flow-title-${i}`} value={s.title} onChange={setStep(i, "title")} className={inputCls} />
                </Field>
                <Field label="短い説明（カードに表示）">
                  <textarea data-testid={`flow-desc-${i}`} rows={2} value={s.desc} onChange={setStep(i, "desc")} className={`resize-y ${inputCls}`} />
                </Field>
                <Field label="詳細（クリック時のポップアップに表示）">
                  <textarea data-testid={`flow-detail-${i}`} rows={3} value={s.detail} onChange={setStep(i, "detail")} className={`resize-y ${inputCls}`} />
                </Field>
              </div>
            ))}
          </div>
        </section>

        <button data-testid="home-save-button" type="submit" disabled={saving} className="w-full bg-accent py-3.5 font-display text-sm font-bold tracking-[0.2em] text-ink transition-colors hover:bg-accent-hover disabled:opacity-50">
          {saving ? "保存中..." : "保存する"}
        </button>
      </form>
    </div>
  );
}
